import { render, staticRenderFns } from "./AddressBar.vue?vue&type=template&id=786bb3bf&scoped=true&"
import script from "./AddressBar.vue?vue&type=script&lang=ts&"
export * from "./AddressBar.vue?vue&type=script&lang=ts&"
import style0 from "./AddressBar.vue?vue&type=style&index=0&id=786bb3bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786bb3bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBadge,VBtn,VIcon,VTextField})
